import tinymce from "tinymce/tinymce";
tinymce.addI18n('fr_FR', {
  "Cut": "Couper",
  "Heading 5": "En-t\xEAte 5",
  "Header 2": "Titre 2",
  "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X\/C\/V keyboard shortcuts instead.": "Votre navigateur ne supporte pas la copie directe. Merci d'utiliser les touches Ctrl+X\/C\/V.",
  "Heading 4": "En-t\xEAte 4",
  "Div": "Div",
  "Heading 2": "En-t\xEAte 2",
  "Paste": "Coller",
  "Close": "Fermer",
  "Font Family": "Police",
  "Pre": "Pre",
  "Align right": "Aligner \xE0 droite",
  "New document": "Nouveau document",
  "Blockquote": "Citation",
  "Numbered list": "Num\xE9rotation",
  "Heading 1": "En-t\xEAte 1",
  "Headings": "En-t\xEAtes",
  "Increase indent": "Augmenter le retrait",
  "Formats": "Formats",
  "Headers": "Titres",
  "Select all": "Tout s\xE9lectionner",
  "Header 3": "Titre 3",
  "Blocks": "Blocs",
  "Undo": "Annuler",
  "Strikethrough": "Barr\xE9",
  "Bullet list": "Puces",
  "Header 1": "Titre 1",
  "Superscript": "Exposant",
  "Clear formatting": "Effacer la mise en forme",
  "Font Sizes": "Taille de police",
  "Subscript": "Indice",
  "Header 6": "Titre 6",
  "Redo": "R\xE9tablir",
  "Paragraph": "Paragraphe",
  "Ok": "Ok",
  "Bold": "Gras",
  "Code": "Code",
  "Italic": "Italique",
  "Align center": "Centrer",
  "Header 5": "Titre 5",
  "Heading 6": "En-t\xEAte 6",
  "Heading 3": "En-t\xEAte 3",
  "Decrease indent": "Diminuer le retrait",
  "Header 4": "Titre 4",
  "Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.": "Le presse-papiers est maintenant en mode \"texte plein\". Les contenus seront coll\xE9s sans retenir les formatages jusqu'\xE0 ce que vous d\xE9sactiviez cette option.",
  "Underline": "Soulign\xE9",
  "Cancel": "Annuler",
  "Justify": "Justifier",
  "Inline": "En ligne",
  "Copy": "Copier",
  "Align left": "Aligner \xE0 gauche",
  "Visual aids": "Aides visuelle",
  "Lower Greek": "Grec minuscule",
  "Square": "Carr\xE9",
  "Default": "Par d\xE9faut",
  "Lower Alpha": "Alpha minuscule",
  "Circle": "Cercle",
  "Disc": "Disque",
  "Upper Alpha": "Alpha majuscule",
  "Upper Roman": "Romain majuscule",
  "Lower Roman": "Romain minuscule",
  "Id should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.": "L'Id doit commencer par une lettre suivi par des lettres, nombres, tirets, points, deux-points ou underscores",
  "Name": "Nom",
  "Anchor": "Ancre",
  "Id": "Id",
  "You have unsaved changes are you sure you want to navigate away?": "Vous avez des modifications non enregistr\xE9es, \xEAtes-vous s\xFBr de quitter la page?",
  "Restore last draft": "Restaurer le dernier brouillon",
  "Special character": "Caract\xE8res sp\xE9ciaux",
  "Source code": "Code source",
  "Language": "Langue",
  "Insert\/Edit code sample": "Ins\xE9rer / modifier une exemple de code",
  "B": "B",
  "R": "R",
  "G": "V",
  "Color": "Couleur",
  "Right to left": "Droite \xE0 gauche",
  "Left to right": "Gauche \xE0 droite",
  "Emoticons": "Emotic\xF4nes",
  "Robots": "Robots",
  "Document properties": "Propri\xE9t\xE9 du document",
  "Title": "Titre",
  "Keywords": "Mots-cl\xE9s",
  "Encoding": "Encodage",
  "Description": "Description",
  "Author": "Auteur",
  "Fullscreen": "Plein \xE9cran",
  "Horizontal line": "Ligne horizontale",
  "Horizontal space": "Espacement horizontal",
  "Insert\/edit image": "Ins\xE9rer/modifier une image",
  "General": "G\xE9n\xE9ral",
  "Advanced": "Avanc\xE9",
  "Source": "Source",
  "Border": "Bordure",
  "Constrain proportions": "Conserver les proportions",
  "Vertical space": "Espacement vertical",
  "Image description": "Description de l'image",
  "Style": "Style",
  "Dimensions": "Dimensions",
  "Insert image": "Ins\xE9rer une image",
  "Image": "Image",
  "Zoom in": "Zoomer",
  "Contrast": "Contraste",
  "Back": "Retour",
  "Gamma": "Gamma",
  "Flip horizontally": "Retournement horizontal",
  "Resize": "Redimensionner",
  "Sharpen": "Affiner",
  "Zoom out": "D\xE9zoomer",
  "Image options": "Options de l'image",
  "Apply": "Appliquer",
  "Brightness": "Luminosit\xE9",
  "Rotate clockwise": "Rotation horaire",
  "Rotate counterclockwise": "Rotation anti-horaire",
  "Edit image": "Modifier l'image",
  "Color levels": "Niveaux de couleur",
  "Crop": "Rogner",
  "Orientation": "Orientation",
  "Flip vertically": "Retournement vertical",
  "Invert": "Inverser",
  "Date\/time": "Date\/heure",
  "Insert date\/time": "Ins\xE9rer date/heure",
  "Remove link": "Enlever le lien",
  "Url": "Url",
  "Text to display": "Texte \xE0 afficher",
  "Anchors": "Ancres",
  "Insert link": "Ins\xE9rer un lien",
  "Link": "Lien",
  "New window": "Nouvelle fen\xEAtre",
  "None": "n\/a",
  "The URL you entered seems to be an external link. Do you want to add the required http:\/\/ prefix?": "L'URL que vous avez entr\xE9e semble \xEAtre un lien externe. Voulez-vous ajouter le pr\xE9fixe http:// n\xE9cessaire?",
  "Paste or type a link": "Coller ou taper un lien",
  "Target": "Cible",
  "The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?": "L'URL que vous avez entr\xE9e semble \xEAtre une adresse e-mail. Voulez-vous ajouter le pr\xE9fixe mailto: n\xE9cessaire?",
  "Insert\/edit link": "Ins\xE9rer/modifier un lien",
  "Insert\/edit video": "Ins\xE9rer/modifier une vid\xE9o",
  "Media": "M\xE9dia",
  "Alternative source": "Source alternative",
  "Paste your embed code below:": "Collez votre code d'int\xE9gration ci-dessous :",
  "Insert video": "Ins\xE9rer une vid\xE9o",
  "Poster": "Publier",
  "Insert\/edit media": "Ins\xE9rer/modifier un m\xE9dia",
  "Embed": "Int\xE9grer",
  "Nonbreaking space": "Espace ins\xE9cable",
  "Page break": "Saut de page",
  "Paste as text": "Coller comme texte",
  "Preview": "Pr\xE9visualiser",
  "Print": "Imprimer",
  "Save": "Enregistrer",
  "Could not find the specified string.": "Impossible de trouver la cha\xEEne sp\xE9cifi\xE9e.",
  "Replace": "Remplacer",
  "Next": "Suiv",
  "Whole words": "Mots entiers",
  "Find and replace": "Trouver et remplacer",
  "Replace with": "Remplacer par",
  "Find": "Chercher",
  "Replace all": "Tout remplacer",
  "Match case": "Respecter la casse",
  "Prev": "Pr\xE9c ",
  "Spellcheck": "V\xE9rification orthographique",
  "Finish": "Finie",
  "Ignore all": "Tout ignorer",
  "Ignore": "Ignorer",
  "Add to Dictionary": "Ajouter au dictionnaire",
  "Insert row before": "Ins\xE9rer une ligne avant",
  "Rows": "Lignes",
  "Height": "Hauteur",
  "Paste row after": "Coller la ligne apr\xE8s",
  "Alignment": "Alignement",
  "Border color": "Couleur de la bordure",
  "Column group": "Groupe de colonnes",
  "Row": "Ligne",
  "Insert column before": "Ins\xE9rer une colonne avant",
  "Split cell": "Diviser la cellule",
  "Cell padding": "Espacement interne cellule",
  "Cell spacing": "Espacement inter-cellulles",
  "Row type": "Type de ligne",
  "Insert table": "Ins\xE9rer un tableau",
  "Body": "Corps",
  "Caption": "Titre",
  "Footer": "Pied",
  "Delete row": "Effacer la ligne",
  "Paste row before": "Coller la ligne avant",
  "Scope": "Etendue",
  "Delete table": "Supprimer le tableau",
  "H Align": "Alignement H",
  "Top": "Haut",
  "Header cell": "Cellule d'en-t\xEAte",
  "Column": "Colonne",
  "Row group": "Groupe de lignes",
  "Cell": "Cellule",
  "Middle": "Milieu",
  "Cell type": "Type de cellule",
  "Copy row": "Copier la ligne",
  "Row properties": "Propri\xE9t\xE9s de la ligne",
  "Table properties": "Propri\xE9t\xE9s du tableau",
  "Bottom": "Bas",
  "V Align": "Alignement V",
  "Header": "En-t\xEAte",
  "Right": "Droite",
  "Insert column after": "Ins\xE9rer une colonne apr\xE8s",
  "Cols": "Colonnes",
  "Insert row after": "Ins\xE9rer une ligne apr\xE8s",
  "Width": "Largeur",
  "Cell properties": "Propri\xE9t\xE9s de la cellule",
  "Left": "Gauche",
  "Cut row": "Couper la ligne",
  "Delete column": "Effacer la colonne",
  "Center": "Centr\xE9",
  "Merge cells": "Fusionner les cellules",
  "Insert template": "Ajouter un th\xE8me",
  "Templates": "Th\xE8mes",
  "Background color": "Couleur d'arri\xE8re-plan",
  "Custom...": "Personnalis\xE9...",
  "Custom color": "Couleur personnalis\xE9e",
  "No color": "Aucune couleur",
  "Text color": "Couleur du texte",
  "Table of Contents": "Table des mati\xE8res",
  "Show blocks": "Afficher les blocs",
  "Show invisible characters": "Afficher les caract\xE8res invisibles",
  "Words: {0}": "Mots : {0}",
  "Insert": "Ins\xE9rer",
  "File": "Fichier",
  "Edit": "Editer",
  "Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help": "Zone Texte Riche. Appuyer sur ALT-F9 pour le menu. Appuyer sur ALT-F10 pour la barre d'outils. Appuyer sur ALT-0 pour de l'aide.",
  "Tools": "Outils",
  "View": "Voir",
  "Table": "Tableau",
  "Format": "Format"
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/core/tinymce/langs/fr_FR.js
// module id = 3030
// module chunks = 13